// Azure AD / MSAL configuration
export const msalConfig = {
  auth: {
    clientId: "08950a0b-c975-4d18-88c6-4544e92c7961",
    authority: "https://login.microsoftonline.com/9628719d-d52a-4235-8b0c-c257f549c919",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    allowNativeBroker: false,
  },
};

// API base URL — the Function App
export const API_BASE = "https://func-claudelogs-ingest.azurewebsites.net/api";

// Delegated scope exposed by the app registration ("Expose an API").
// Access tokens for this scope carry the api://<clientId> audience the
// Function App validates.
export const API_SCOPE = "api://08950a0b-c975-4d18-88c6-4544e92c7961/user_impersonation";

export const loginRequest = {
  scopes: ["openid", "profile", "email", API_SCOPE],
};
